import { ConditionalFormattingRule } from './conditional-formatting.model';
import { fieldId } from './field-id.model';

export enum ColorType {
  Continuous = 'continuous',
  Piecewise = 'piecewise',
}

export interface ColorPiece {
  color: string;
  min?: number;
  max?: number;
  label?: string;
}

export type SeriesConditionalFormattingRule = ConditionalFormattingRule & {
  fieldId: fieldId | undefined;
  colorByFieldId: fieldId | undefined;
  colors: Array<string | undefined>;
  colorPiece: ColorPiece | undefined;
  type: ColorType;
  groupId: string;
};

export interface SeriesConditionalFormattingGroup {
  fieldIds: fieldId[];
  colorByFieldId?: fieldId;
  type: ColorType;
  rules: SeriesConditionalFormattingRule[];
  groupId: string;
}
